import React, { useState } from 'react';
import { openAuthenticatedFile, isDirectMediaSrc, resolveFileUrl } from '../../api/mediaUrl';

/** Link/button that opens a private stored file with JWT authentication. */
export function AuthenticatedFileLink({ fileRef, children, className, onError }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e) => {
    e.preventDefault();
    const trimmed = String(fileRef || '').trim();
    if (!trimmed) return;

    if (isDirectMediaSrc(trimmed)) {
      window.open(trimmed, '_blank', 'noopener,noreferrer');
      return;
    }

    setLoading(true);
    try {
      await openAuthenticatedFile(trimmed);
    } catch (err) {
      onError?.(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={className}
      onClick={handleClick}
      disabled={loading}
    >
      {loading ? 'Opening…' : children}
    </button>
  );
}

/** Anchor styled link variant for inline "View" actions. */
export function AuthenticatedFileViewLink({ fileRef, label = 'View', className = 'font-medium text-primary-600 hover:underline' }) {
  return (
    <AuthenticatedFileLink fileRef={fileRef} className={className}>
      {label}
    </AuthenticatedFileLink>
  );
}

export { resolveFileUrl };
